<template>
  <div
    v-if="
      $store.state.app.user.indexOf($store.state.auth.uid) > -1 ||
      ($store.state.app.advanced.roles.admin && $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.indexOf(
          $store.state.auth.uid
        ) > -1)
    "
  >
    <h1>API and Function Generator</h1>

    <div class="flex wrap">
      <div class="flex wrap" style="overflow: scroll">
        <function />

        <div class="flex wrap">
          <div class="label white flex wrap align-center p4 m4">
            <b>Custom API </b>
            <span class="xs-font l8 r8">
              [
              <span
                :style="externalApi.verb === verb ? 'font-weight: 900;' : ''"
                :class="externalApi.verb === verb ? 'indicate-text' : ''"
                class="xs-font p4"
                @click="
                  externalApi.verb = verb;
                  test = 'axios.' + externalApi.verb;
                "
                v-for="(verb, verbKey) in verbs"
                :key="verbKey"
                :value="verb"
                >{{ verb }}</span
              >
              ]
            </span>
            <input
              class="sm-input xs-font flexy fill"
              type="text"
              v-model="externalApi.address"
              :placeholder="`${externalApi.verb} url`"
            />
          </div>
          <div class="sub-container flex wrap between align-center p4 m4">
            <div class="flex align-center between flexy">
              <b>Site API</b>

              <a
                v-if="!runtest.testing"
                @click="runtests()"
                class="xs-font p4 update-text"
              >
                Run Tests
              </a>
              <input
                placeholder="Search endpoints"
                type="text"
                v-model="apisearch"
                class="xs-font xs-input"
              />
            </div>
            <code
              @click="
                method = false;
                data = '{}';
                test = 'axios.' + externalApi.verb;
              "
              class="xs-font flex wrap"
            >
              <a
                v-for="(api, apikey) in $store.state.app.advanced.api"
                :key="apikey"
                @mouseenter="$set(show, api.verb + api.name, true)"
                @mouseleave="show[api.verb + api.name] = false"
                @click.prevent="
                  externalApi.hook = api.hook;
                  externalApi.address = api.address || api.endpoint;
                  externalApi.verb = api.verb;
                  api.model
                    ? ((externalApi.data =
                        typeof api.model === 'object'
                          ? api.model
                          : JSON.parse(api.model)),
                      (externalApi.rawdata = JSON.stringify(api.model)))
                    : null;
                "
                class="flex"
                ><span
                  v-if="
                    JSON.stringify(api)
                      .toLowerCase()
                      .includes(apisearch.toLowerCase())
                  "
                  :class="show[api.verb + api.name] ? 'update-text' : ''"
                  class="m4 container p4"
                  ><i>( {{ api.verb }} )</i> <b>{{ api.name }}</b></span
                >
              </a>
            </code>
          </div>
        </div>
      </div>

      <div
        v-if="method || externalApi.address || runtest.testing"
        class="flex column container flexx"
        style="max-width: 480px; overflow: scroll"
      >
        <div v-if="method">
          <code
            v-if="jsond && !externalApi.address"
            @click="
              jsond = false;
              data = JSON.stringify(data, null, 2);
            "
            >{{ data }}</code
          >
          <textarea
            class="sm-font fill"
            style="min-height: 40vh"
            v-if="!jsond || externalApi.address"
            id="test-data"
            v-model="data"
            placeholder="Valid JSON string"
          ></textarea>
          <button
            v-if="!returnVal"
            :class="
              method === 'action'
                ? 'success p8'
                : method === 'mutation'
                ? 'update p8'
                : 'indicate p8'
            "
            @click="
              !jsond ? ((data = JSON.parse(data)), (jsond = true)) : null;
              method === 'action'
                ? testAction()
                : method === 'mutation'
                ? testMutation()
                : testMethod();
            "
            type="button"
          >
            {{
              method === "action"
                ? "Dispatch"
                : method === "mutation"
                ? "Commit"
                : "Hit Endpoint"
            }}
          </button>
        </div>
        <!-- TESTING -->
        <div v-if="runtest.testing">
          <div
            class="v-scroll label p4 xs-font b8 fill-h"
            style="max-height: 94vh"
          >
            <div class="flex align-center between p4 container">
              <span
                :class="
                  runtest.errors.length > 0
                    ? 'warn-text'
                    : runtest.testingoutput.length !==
                      $store.state.app.advanced.api.length
                    ? 'success'
                    : 'success-text'
                "
                >{{
                  runtest.testingoutput.length !==
                  $store.state.app.advanced.api.length
                    ? "Running tests " +
                      Math.floor(
                        (runtest.testingoutput.length /
                          $store.state.app.advanced.api.length) *
                          100
                      ) +
                      "%"
                    : "Test Complete 100%"
                }}</span
              >
              <a
                @click="
                  runtest.testingoutput = [];
                  runtest.testing = false;
                "
                class="xs-font"
              >
                Clear
              </a>
            </div>
            <div
              class="warn-text"
              v-for="(error, errori) in runtest.errors"
              :key="errori"
            >
              {{ error }}
            </div>
            <div
              :class="
                show['testdata' + result.verb + result.name]
                  ? 'sub-container'
                  : ''
              "
              class="xs-font p4"
              v-for="result in runtest.testingoutput"
              :key="'test' + result.verb + result.name"
              @click="
                $set(
                  show,
                  'testdata' + result.verb + result.name,
                  !show['testdata' + result.verb + result.name]
                )
              "
            >
              <div class="flex between">
                <span>
                  <span>{{ result.verb }}: </span>
                  <b>{{ result.name }}</b>
                </span>
                <span
                  :class="result.status == '200' ? 'success-text' : 'warn-text'"
                  >{{ result.status }}
                </span>
              </div>
              <span
                class="flex between align-center"
                :class="result.status == '200' ? 'success-text' : 'warn-text'"
                v-if="show['testdata' + result.verb + result.name]"
                ><code>{{ result.response }}</code>
                <i
                  @click="
                    $set(runtest, 'testing', false);
                    externalApi = result;
                  "
                  class="far fa-cloud-upload fa-2x"
                />
              </span>
            </div>
          </div>
        </div>

        <!-- RETURN -->
        <div v-else class="flex align-end column">
          
          <div class="flex between">
            <div class="xs-font">
              <button
                class="xs-font p4"
                v-if="runtest.testingoutput.length > 0"
                type="button"
                @click="runtest.testing = true"
              >
                Test Results
              </button>
              <code>{{ externalApi.verb || test }}(</code>
              <b>{{ externalApi.address }}</b
              ><code>)</code>
            </div>
            <button
              v-if="!returnVal"
              class="sm-font flexx"
              :class="
                method === 'action'
                  ? 'success p4'
                  : method === 'mutation'
                  ? 'update p4'
                  : 'success p4'
              "
              @click="
                validjson(externalApi.rawdata) && !jsond
                  ? (jsond = true)
                  : null;
                method === 'action'
                  ? testAction()
                  : method === 'mutation'
                  ? testMutation()
                  : testMethod(
                      externalApi.address,
                      externalApi.verb,
                      externalApi.rawdata,
                      null,
                      externalApi.hook
                    );
              "
              type="button"
            >
              {{
                method === "action"
                  ? "Dispatch"
                  : method === "mutation"
                  ? "Commit"
                  : "Hit Endpoint"
              }}
            </button>
          </div>
          <label
            v-if="!returnVal && externalApi.verb !== 'get'"
            for="test-data"
            class="flex container column fill b8"
          >
            <code
              v-if="jsond && !externalApi.address"
              @click="
                jsond = false;
                data = JSON.stringify(data, null, 2);
              "
              >{{ data }}</code
            >
            <div
              v-if="
                (!jsond || externalApi.address) &&
                'postdeletesetoptionsputpatch'.includes(
                  externalApi.verb.toLowerCase()
                )
              "
            >
              <div
                v-if="externalApi.verb !== 'get'"
                class="flex align-center wrap"
              >
              <iinput name="api" v-model="externalApi.data" />
                <a
                  class="xs-font p4 indicate-text"
                  v-if="
                    'postdeletesetoptionsput'.includes(
                      externalApi.verb.toLowerCase()
                    )
                  "
                  @click="rawmode = !rawmode"
                >
                  {{ !rawmode ? "Text Mode" : "Input Mode" }}
                </a>
              </div>
              <div v-if="rawmode || !externalApi.data">
                <code v-if="jsonerror" class="warn label xs-font"
                  >Data must be valid JSON</code
                >
                <textarea
                  class="sm-font fill"
                  :class="jsonerror ? 'warn-text' : ''"
                  style="min-height: 40vh"
                  @input="
                    validjson(externalApi.rawdata)
                      ? (externalApi.data = JSON.parse(externalApi.rawdata))
                      : null
                  "
                  id="test-data"
                  v-model="externalApi.rawdata"
                  placeholder="Valid JSON string"
                ></textarea>
              </div>
              <state
                v-if="!rawmode && externalApi.data"
                list="true"
                editable="json"
                createable="true"
                :key="'apistate' + externalApi.rawdata.length"
                :statedata="externalApi.data"
                parent="externalApi.data"
                v-model="externalApi.data"
                :nesting="0"
              />
            </div>
          </label>

          <div
            v-if="returnVal"
            style="overflow: scroll"
            class="fill-h fill container p4"
          >
            <div class="flex between wrap align-center xs-font">
              <b>Output:</b>
              <input placeholder="name api" type="text" class="xs-input" v-model="inputs['saveendpointname']">
              <button class="xs-font update" :disabled="!inputs['saveendpointname']" type="button" @click="inputs['saveendpoint'] = {address:externalApi.address, verb: externalApi.verb, name: inputs['saveendpointname'], model: externalApi.rawdata};!$store.state.app.advanced.api.includes(inputs['saveendpoint']) && $store.state.app.advanced.api.push(inputs['saveendpoint']) && $store.dispatch('update', {type: 'app', data: $store.state.app})"><i class="fas fa-asterisk r4"></i> Save to Site API</button>
              
              <button
                v-if="!save"
                @click="save = true"
                class="update xs-font"
                type="button"
              >
                <i class="fas fa-save r4"></i> Save Data
              </button>
              <button
                v-if="save"
                @click="save = false"
                class="update sm-font"
                type="button"
              >
                <i class="fas fa-times r4"></i> Cancel Save Mode
              </button>
              <div v-if="save" class="flex wrap around xs-font">
                <input
                  v-model="variable.datatype"
                  class="sm-input"
                  type="text"
                  placeholder="Type / Folder"
                />
                <input
                  v-model="variable.key"
                  class="sm-input"
                  type="text"
                  placeholder="Key / Variable"
                />
                <button
                  @click="
                    $store.dispatch('create', {
                      type: 'value',
                      datatype: variable.datatype,
                      key: variable.key,
                      value: JSON.stringify(returnVal),
                    })
                  "
                  type="button"
                >
                  Assign
                </button>
              </div>
              <button
                @click="returnVal = false"
                class="warn xs-font"
                type="button"
              >
                <i class="fas fa-trash r4"></i> Clear Data
              </button>
            </div>
            <state
              createable="true"
              editable="true"
              list="true"
              :statedata="returnVal"
              :nesting="0"
              :parent="externalApi.address"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <logs /> -->
  </div>
  <login v-else />
</template>
<script>
export default {
  data() {
    return {
      apisearch: "",
      examples: [
        "https://api.nasa.gov/planetary/apod?api_key=NNKOjkoul8n1CH18TWA9gwngW1s1SmjESPjNoUFo",
        "https://us-central1-p3c-prsprty.cloudfunctions.net/test",
      ],
      externalApi: {
        address: "",
        verb: "get",
        data: {},
        rawdata: "",
      },
      jsond: true,
      jsonerror: false,
      test: "",
      runtest: {
        testing: false,
        testingoutput: [],
        errors: [],
      },
      data: "",
      local: false,
      localsrc: "",
      inputs: {},
      method: false,
      rawmode: false,
      returnVal: false,
      save: false,
      show: {},
      tokenType: "",
      txCreate: {
        to: "",
        address: "",
        amount: 0,
        fee: 0,
        sign: "",
      },
      variable: {
        type: "",
        key: "",
      },
      verbs: ["get", "post", "put", "delete", "patch", "options"],
    };
  },
  methods: {
    runtests() {
      this.runtest.testingoutput = [];
      this.runtest.testing = true;
      this.$store.state.app.advanced.api.map(async (x) => {
        await this.testMethod(x.address || x.endpoint, x.verb, x.model, true).then((d) => {
          d.status !== 200 && this.runtest.errors.push(d);
          let pushobj = {
            address: x.address || x.endpoint,
            name: x.name,
            verb: x.verb,
            status: d.status,
            response:
              typeof d.data == "string" ? d.data : "Error: " + d.data.error,
          };
          if (x.model) {
            typeof x.model === "string" && this.validjson(x.model)
              ? ((pushobj.data = JSON.parse(x.model)),
                (pushobj.rawdata = x.model))
              : ((pushobj.data = x.model),
                (pushobj.rawdata = JSON.stringify(x.model)));
          }
          this.runtest.testingoutput.push(pushobj);
        });
      });
    },
    validjson(str) {
      try {
        JSON.parse(str);
        this.$set(this, "jsonerror", false);
        return true;
      } catch (e) {
        this.$set(this, "jsonerror", true);
        return false;
      }
    },
    testAction() {
      return this.$store.dispatch(this.test, this.data).then((data) => {
        return this.$set(this, "returnVal", data);
      });
    },
    testMutation() {
      return this.$store.commit(this.test, this.data);
    },
    testMethod(address, verb, data, test, hook) {
      return this.$store
        .dispatch("api", {
          hook: hook,
          address: address,
          verb: verb,
          data: this.validjson(data) ? this.externalApi.data : {},
          local: this.local,
        })
        .then((data) => {
          !test && this.$set(this, "returnVal", data);
          return data;
        });
    },
  },
  name: "api",
  // async mounted() {
  //   await this.$store.dispatch("query", {
  //     type: "user",
  //     id: this.user || this.$store.state.auth.uid,
  //   });
  // },
  watch: {
    "externalApi.data": {
      handler: function (val) {
        this.externalApi.rawdata = JSON.stringify(val);
      },
    },
  },
};
</script>